import { useQuery } from '@tanstack/react-query';
import { listTriggers } from '@/services/triggers/triggers';
import { Trigger } from '@/services/triggers/types';

export const triggersQueryKey = (orgId?: string, workflowId?: string) =>
  workflowId ? ['triggers', orgId, workflowId] : ['triggers', orgId];

export const useListTriggers = (
  orgId?: string,
  // Scopes the list to one workflow's Triggers section. Filtering server-side
  // avoids a subscriptions request per trigger just to find this workflow's.
  workflowId?: string,
  enabled = true,
) =>
  useQuery<Trigger[]>({
    queryKey: triggersQueryKey(orgId, workflowId),
    queryFn: () => listTriggers(orgId!, workflowId),
    enabled: !!orgId && enabled,
  });
